module.exports = __webpack_public_path__ + "img/chip_selector.81008209.png";